import { render, staticRenderFns } from "./resume-v2.vue?vue&type=template&id=7dc0b7be&scoped=true&"
import script from "./resume-v2.vue?vue&type=script&lang=js&"
export * from "./resume-v2.vue?vue&type=script&lang=js&"
import style0 from "./resume-v2.vue?vue&type=style&index=0&id=7dc0b7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0b7be",
  null
  
)

export default component.exports